// src/pages/Rides.js
import React, { useState, useEffect } from 'react';
import { listenToRides, updateRide } from '../services/firebase';
import toast from 'react-hot-toast';

export default function Rides() {
  const [rides, setRides] = useState([]);
  const [filter, setFilter] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => { return listenToRides(filter, setRides); }, [filter]);

  const filtered = rides.filter(r =>
    !search ||
    r.destination?.name?.toLowerCase().includes(search.toLowerCase()) ||
    r.driverName?.toLowerCase().includes(search.toLowerCase()) ||
    r.id.includes(search)
  );

  const statusColor = (s) => {
    if (s === 'completed') return 'badge-green';
    if (s === 'searching') return 'badge-orange';
    if (s === 'cancelled') return 'badge-red';
    if (['driver_assigned', 'arrived', 'started'].includes(s)) return 'badge-blue';
    return 'badge-gray';
  };

  const totalRevenue = rides.filter(r => r.status === 'completed').reduce((s, r) => s + (r.fare || 0), 0);

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Rides</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>
          {rides.length} rides • <span style={{ color: 'var(--green)' }}>₹{totalRevenue} revenue</span>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 280 }}>
          <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
          <input placeholder="Search rides..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 32 }} />
        </div>
        {['all', 'searching', 'driver_assigned', 'started', 'completed', 'cancelled'].map(f => (
          <button key={f} className={`btn ${filter === f ? 'btn-green' : 'btn-ghost'} btn-sm`} onClick={() => setFilter(f)} style={{ padding: '8px 12px', fontSize: 11, textTransform: 'capitalize', fontFamily: 'JetBrains Mono' }}>
            {f.replace('_', ' ')}
          </button>
        ))}
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>PICKUP</th>
              <th>DESTINATION</th>
              <th>DRIVER</th>
              <th>DISTANCE</th>
              <th>FARE</th>
              <th>OTP</th>
              <th>PAYMENT</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={9} style={{ textAlign: 'center', color: 'var(--text2)', padding: 32 }}>No rides found</td></tr>
            ) : filtered.map(r => (
              <tr key={r.id}>
                <td><span style={{ fontFamily: 'JetBrains Mono', fontSize: 10, color: 'var(--text2)' }}>#{r.id.slice(0, 6)}</span></td>
                <td style={{ maxWidth: 120 }}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 12, color: 'var(--text2)' }}>{r.pickup?.address?.split(',')[0] || '—'}</div></td>
                <td style={{ maxWidth: 140 }}><div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>{r.destination?.name || '—'}</div></td>
                <td>{r.driverName || <span style={{ color: 'var(--text2)', fontSize: 12 }}>Unassigned</span>}</td>
                <td style={{ fontFamily: 'JetBrains Mono', fontSize: 12 }}>{r.distance || '—'}</td>
                <td style={{ fontFamily: 'JetBrains Mono', color: 'var(--green)', fontWeight: 700 }}>₹{r.fare || '—'}</td>
                <td><span style={{ fontFamily: 'JetBrains Mono', fontSize: 13, fontWeight: 700, color: 'var(--orange)' }}>{r.otp || '—'}</span></td>
                <td><span className={`badge ${r.paymentMode === 'cash' ? 'badge-gray' : 'badge-blue'}`}>{r.paymentMode || 'cash'}</span></td>
                <td><span className={`badge ${statusColor(r.status)}`}>{r.status?.replace('_', ' ')}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
